import React, { FC } from 'react';
import { ErrorBoundary as ReactErrorBoundary } from 'react-error-boundary';
import { IoCloseCircleOutline } from 'react-icons/io5';

import { Box, Button, Flex, Text, Title } from '@mantine/core';

import { FeedbackButton } from 'components/buttons/FeedbackButton';
import { SentryService } from 'services/SentryService';

const ErrorBoundary: FC<{
    children: React.ReactNode;
    force?: boolean;
    onError?: () => void;
}> = ({ children, force = false, onError }) => {
    const handleError = (error: unknown) => {
        onError?.();
        SentryService.reportError(error);
    };

    return (
        <ReactErrorBoundary fallback={<Fallback />} onError={handleError}>
            {force ? <Fallback /> : children}
        </ReactErrorBoundary>
    );
};

const Fallback = () => (
    <Box
        style={{
            display: 'flex',
            flexDirection: 'column',

            justifyContent: 'center',
            alignItems: 'center',

            gap: 16,

            margin: 'auto',

            textAlign: 'center',
        }}
    >
        <IoCloseCircleOutline size={64} strokeWidth={1.25} className="animation-pulse" />
        <Title>Something went wrong</Title>
        <Text>
            Unfortunately an error occurred in the background.
            <br />
            Refresh the page to try again as it may be a temporary issue.
        </Text>
        <Button
            onClick={() => {
                window.location.reload();
            }}
        >
            Refresh
        </Button>
        <Flex c="dimmed">
            If the issue keeps resurfacing please&nbsp;
            <FeedbackButton isInline label="Submit feedback" />
        </Flex>
    </Box>
);

export { ErrorBoundary };
